window.mosaic = window.mosaic || {}
/**
 * @private
 * @type {{secondary: string, 'advanced-green': string, light: string, advanced: string, success: string, dark: string, warning: string, danger: string, muted: string, 'advanced-sky': string, primary: string, info: string}}
 */
window.mosaic.colors = {
  primary: '#1d428a',
  secondary: '#414141',
  success: '#00823b',
  info: '#007377',
  warning: '#ffc107',
  danger: '#dc3545',
  light: '#f8f8f8',
  dark: '#242424',
  advanced: '#e9510e',
  'advanced-sky': '#009FDF',
  'advanced-green': '#009A44',
  muted: '#767676'
}
